import AddForm from "../../components/AddForm";
import { Form, Button, Row, Col } from 'react-bootstrap';
import { useState } from "react";
import { default as ReactSelect } from "react-select";
import axios from 'axios'
import {useSelector} from 'react-redux'
import { useEffect } from "react";
import { useLocation,useNavigate} from 'react-router-dom'
import PopUpModal from "../../components/PopupModal";
import { Alert } from "@mui/material";
import UploadImage from "../../components/ImageUpload";

const ServiceProviderRegister = () => {
    const loc = useLocation();
    const id = loc.state.id;
    const {user} = useSelector((state)=> state.auth);
    const userId = user.seller_profile_id;
    const [category, setCategory] = useState();
    const [categoryOptions, setCategoryOptions] = useState();
    const [serviceName, setserviceName] = useState();
    const [email, setEmail] = useState()
    const [serviceType, setserviceType] = useState();
    const [serviceSpeciality, setserviceSpeciality] = useState();
    const [number, setNumber] = useState();
    const [alternativeNumber, setalternativeNumber] = useState();
    const [location, setLocation] = useState();
    const [timings, setTimings] = useState();
    const [openingDays, setOpeningDays] = useState([]);
    const [charges, setcharges] = useState();
    const [details, setdetails] = useState('')
    const [days, setDays] = useState([]);
    const [file, setFile] = useState(null);
    const getFile = (f)=> {
        setFile(f);
    }
    const [error, setError] = useState('');

    const [modal, setModal] = useState(false);
    const navigate = useNavigate();

    useEffect(()=> {
        navigator.geolocation.getCurrentPosition((props)=> {
            setLocation([props.coords.latitude,props.coords.longitude])
        })
    }, []);
    const shop_location = JSON.stringify(location);

    useEffect(() => {
        const getCategory = async () => {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/category/get-service-provider`, {withCredentials: true}).then((res) => {
                const getData = res.data.data.map((d) => ({ value: d.category_id, label: d.category_name }))
                setCategoryOptions(getData)
            })
        }
        getCategory()
    }, []);

    const Select = (props) => {
        return (
            <div>
                <Select {...props}>
                    <input
                        type=""
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </Select>
            </div>
        );
    };
    const daysOptions = [
        { value: "mon", label: "Mon" },
        { value: "tue", label: "Tue" },
        { value: "wed", label: "Wed" },
        { value: "thur", label: "Thu" },
        { value: "fri", label: "Fri" },
        { value: "sat", label: "Sat" },
        { value: "sun", label: "Sun" }
    ];
    const handleChange = (selected) => {
        const selectDays = selected.map((day) => day.value)
        setOpeningDays(selected);
        setDays(selectDays)
    }

    const opening_days = JSON.stringify(days);

    const handleSubmit = async(e)=> {
        e.preventDefault();
        const newService = {
            seller_profile_id: userId,
            category_id: category.value,
            service_name: serviceName,
            service_provider_email:email,
            service_type: serviceType,
            service_speciality: serviceSpeciality,
            service_number: number,
            service_provider_alternative_number: alternativeNumber,
            service_provider_map_location: shop_location,
            service_charges: charges,
            service_timings: timings,
            service_opening_days: opening_days,
            service_details: details
        }
        if(file) {
            const data = new FormData();
            const filename = Date.now() + file.name;
            data.append("name", filename);
            data.append("file", file);
            newService.images = filename;
            try {
            await axios.post("/upload", data);
            } catch (error) {
            console.log(error);
            }
        }
        try {
            const res = await axios.post(process.env.REACT_APP_FIND_API_URL + `/serviceProvider-services/add-serviceProviderServices`, newService, {withCredentials: true});
            if(res.data) {
                setTimeout(()=> setModal(false), 1000);
                navigate('/admin/dashboard')
            }
        } catch (error) {
            setError(error)
        }
    }
    return (
        <>
            <AddForm title={'Register Your Service'} >
                {<PopUpModal title="Service Registered Successfully." show={modal} onHide={() => setModal(false)} />}
                {error && <Alert severity="error">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Select Category</Form.Label>
                                <ReactSelect placeholder="Select Category" options={categoryOptions} onChange={(e) => setCategory(e)} value={category} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Service Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter Service Name" value={serviceName} onChange={(e) => setserviceName(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Service Type</Form.Label>
                                <Form.Control type="text" placeholder="Enter Service Type" value={serviceType} onChange={(e) => setserviceType(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Service Speciality</Form.Label>
                                <Form.Control type="text" placeholder="Enter Service Speciality" value={serviceSpeciality} onChange={(e) => setserviceSpeciality(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control type="number" placeholder="Enter Phone Number" value={number} onChange={(e) => setNumber(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Alternative Phone Number</Form.Label>
                                <Form.Control type="number" placeholder="Enter Alternative Phone Number" value={alternativeNumber} onChange={(e) => setalternativeNumber(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Opening Days</Form.Label>
                                <ReactSelect
                                            classNamePrefix='react-select-container'
                                            options={daysOptions}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{
                                                Select
                                            }}
                                            onChange={handleChange}
                                            allowSelectAll={true}
                                            value={openingDays}
                                        />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Opening Timings</Form.Label>
                                <Form.Control type="text" placeholder="e.g 9am-5pm" value={timings} onChange={(e) => setTimings(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Service Charges</Form.Label>
                                <Form.Control type="text" placeholder="Enter Service Charges" value={charges} onChange={(e) => setcharges(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="12">
                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>Service Details</Form.Label>
                                <Form.Control as="textarea" placeholder='Enter Service Details...' rows={3} value={details} onChange={(e)=> setdetails(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="12">
                            { file &&
                                <div>
                                    <img className='rounded' width="130px" height="130" src={URL.createObjectURL(file)} alt={file} />
                                </div>
                            }
                            <UploadImage title="Image" getFile={getFile} />
                        </Col>
                    </Row>
                    <div>
                        <Button variant="primary" type="submit" className="w-100">
                            Submit
                        </Button>
                    </div>
                </Form>
            </AddForm>
        </>
    );
}

export default ServiceProviderRegister;